/**
 * 公共获取全局属性相关方法
 */
import { Vue, Component } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

@Component({})
export default class AttributeMixin extends Vue {

  @Getter('comm/attributeData') private attributeData: any; // 基础类型对象

  // 根据属性id，获取属性值（如attributeData['xxx']）（用于列表展示）
  private renderAttribute(h: any, row: any, target: any) {
    const data: any = this.attributeData[target.aKey];
    if (!data) {
      return h('span', '');
    }
    const result: any = data.find((item: any) => item.id === row[target.rKey]);
    let name = result ? (result.value || result.name) : '';
    const split = target.split;
    if (split && name.indexOf(split) !== -1) { // 取split标识后面的
      name = name.split(split)[1];
    }
    return h('span', name);
  }
}
